
import { Check } from 'lucide-react';

export const ThankYouMessage = () => {
  return (
    <div className="text-center py-8 px-6">
      <div className="mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
          <Check className="h-8 w-8 text-green-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Thank You!</h2>
        <p className="text-gray-600 mb-4">Your submission has been received.</p>
        <p className="text-sm text-gray-500 mb-6">
          Our team will review your message and get back to you within 24 business hours.
        </p>
        <p className="text-xs text-gray-400">
          (You can now close this window.)
        </p>
      </div>
    </div>
  );
};
